export default {"src":"/_next/static/media/wallet.d3f8462f.svg","height":45,"width":46,"blurWidth":0,"blurHeight":0};